import { inject as service } from '@ember/service';
import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';
import { fetchPageNotifications } from 'mewe/fetchers/fetch-pages-notifications';
import { ds } from 'mewe/stores/ds';
import api from 'mewe/api/pages-api';
import PS from 'mewe/utils/pubsub';

export default Route.extend({
  theme: Theme.PAGE,

  routing: service('-routing'),

  id() {
    return this.modelFor('app.publicid').page.id;
  },

  redirect() {
    const model = this.modelFor('app.publicid');

    if (!model || !model.page || !model.page.name) return;

    if (model.page.isOwnerAdmin) {
      this._super();
    } else {
      this.routing.transitionTo('app.publicid.feed', []);
    }
  },

  beforeModel() {
    let id = this.id();

    let page = this.modelFor('app.publicid').page;

    if (page && page.isOwnerAdmin) {
      fetchPageNotifications(id).then((notifications) => {
        if (notifications.length) {
          api.notificationMarkSeen({ id: id, notificationId: notifications[0].id });
        }
        page.set('unseenCount', 0);

        PS.Sub('page.notification.new', (data) => {
          if (data.pageId === id) {
            page.set('unseenCount', data.unseenCount);
          }
        });
      });
    }
  },

  model() {
    return {
      app: this.modelFor('app'),
      page: this.modelFor('app.publicid').page,
      notifications: ds.notifications.for(this.id()),
    };
  },

  actions: {
    willTransition() {
      PS.Unsub('page.notification.new', 'clearAll');
    },
  },
});
